import React from 'react';

export const NoAccessIcon = ({
  width = '38',
  height = '38',
  color = '#B42318',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M7.21665 7.21659L30.7833 30.7833M35.6666 18.9999C35.6666 28.2047 28.2047 35.6666 19 35.6666C9.79523 35.6666 2.33331 28.2047 2.33331 18.9999C2.33331 9.79517 9.79523 2.33325 19 2.33325C28.2047 2.33325 35.6666 9.79517 35.6666 18.9999Z"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
